import {
  OVField,
  OVSearchable,
  OVEntity,
  OVForm,
  OVTable
} from '@ov-suite/ov-metadata';

@OVEntity('VehicleType', 'shared')
@OVForm([['name']])
// @OVSidebar([['status'], ['id']])
@OVTable<VehicleType>([
  {
    key: 'id',
    title: 'Vehicle ID',
    type: 'string'
  },
  {
    key: 'name',
    title: 'Vehicle Type',
    type: 'string'
  }
])
export class VehicleType {
  @OVField({
    type: 'string',
    title: 'Unique ID',
    sidebar: true,
    generated: true,
    readonly: true
  })
  id: number;

  @OVSearchable()
  @OVField({
    type: 'string',
    title: 'Vehicle Type',
    placeholder: 'Required',
    required: true
  })
  name: string;
}
